import React from "react";
import AncestryMediaGrid from "../../../polotno/ancestry/ancestryMediaGrid";
import styled from "styled-components";
import produce from "immer";

const ScrollablePanel = styled.div`
  height: 400px;
  overflow: auto;
`;

const AllPhotosPanel = ({ selectedPhotos, onChange } = {}) => {
  return (
    <ScrollablePanel>
      <AncestryMediaGrid isVisible
        selectedIds={selectedPhotos}
        onSelect={(item, previewWidth, previewHeight) => {
          onChange(value =>
            produce(value, draft => {
              const id = item.ancestryPhoto.id
              if (value[id]) {
                delete draft[id];
              } else {
                draft[id] = {
                  ...item.ancestryPhoto,
                  previewWidth,
                  previewHeight,
                };
              }
            }),
          );
        }}
        columnCount={6}
      />
    </ScrollablePanel>
  );
}

export default AllPhotosPanel;
